<template>
    <b-navbar fixed-top>
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: homePath }">
                <img
                    src="../assets/logo.png"
                    alt="Spifi Macs"
                >
            </b-navbar-item>
        </template>
        <template slot="start">
            <b-navbar-item tag="router-link" :to="{ path: '/todos' }" v-if="isAuthenticated">
                To-dos
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/about' }">
                About
            </b-navbar-item>
        </template>

        <template slot="end">
            <b-navbar-item tag="div">
                <div class="buttons">
                    <button class="button" @click="openLogin" v-if="!isAuthenticated">Sign In</button>
                    <button class="button" @click="logoutFromFirebase" v-else>Sign Out</button>
                </div>
            </b-navbar-item>
        </template>
    </b-navbar>
</template>

<script>
import SigninVue from '@/components/auth/SignIn.vue'

export default {
  name: 'Navbar',
  computed: {
      isAuthenticated () {
          return this.$store.state.authenticated
      },
      homePath () {
          if (this.isAuthenticated) {
              return '/todos'
          } else {
              return '/'
          }
      }
  },
  methods: {
        logoutFromFirebase () {
            // first show a confirmation thing

            this.$buefy.dialog.confirm({
                title: 'Leaving?',
                message: 'No Problem. <br>We\'ll be here when you get back.',
                confirmText: 'Ciao',
                type: 'is-warning',
                hasIcon: true,
                icon: 'hand-paper',
                cancelText: 'Stay here',
                onConfirm: () => {
                    this.$store.dispatch('signOutAction')
                    .then(() => {
                        this.$buefy.toast.open({
                            message: 'Come back soon!',
                            type: 'is-primary',
                            position: 'is-bottom'
                        })
                    })
                }
            })

        },
        openLogin() {
            this.$buefy.modal.open({
                parent: this,
                component: SigninVue,
                hasModalCard: true,
                trapFocus: true
            })
        },
  }
}
</script>